<template>
  <v-container>
    <v-row class="mb-4">
      <v-col
        class="bordered bg-white"
        cols="8">
        <DataTable
          :headers="headers"
          :items="toolsAndFixtures" />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        class="bordered bg-white"
        cols="6">
        <v-table class="bottom_table">
          <tbody>
            <tr>
              <td class="wide_col">
                {{
                  $t(
                    "entities.manufacturingStep.fields.tool_and_fixture_costs_manufacturing_step_part_long"
                  )
                }}
              </td>
              <td class="input_col">
                <CalcOutput
                  :id="nodeId"
                  field="tool_and_fixture_costs_manufacturing_step_part"
                  hide-label
                  element-type="manufacturingStep"
                  width="80" />
              </td>
              <td class="e_per_piece_col">
                {{ $t("units.e_per_piece_long") }}
              </td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
      <v-col cols="6"> &nbsp; </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useTranslation } from "i18next-vue";
import { useSpaceStore } from "@/stores/spaceStore";
import CalcOutput from "../../../../components/Elements/CalcOutput.vue";
import DataTable from "@/components/Elements/DataTable.vue";

const spaceStore = useSpaceStore();

const { t } = useTranslation();
const step = ref(null);
const tool_and_fixture_costs_manufacturing_step_part = ref(Math.random() * 100);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const toolsAndFixtures = computed(() => {
  return spaceStore
    .getElementList(props.nodeId, "machine")
    .reduce((result, machine) => {
      return [
        ...result,
        ...spaceStore
          .getElementList(machine.fullId, "setupStep")
          .reduce((resultInner, step) => {
            return [
              ...resultInner,
              ...spaceStore.getElementList(step.fullId, "tool"),
              ...spaceStore.getElementList(step.fullId, "fixture")
            ];
          }, [])
      ];
    }, []);
});

onMounted(() => {
  step.value = spaceStore.calculationElements[props.nodeId];
});

const headers = computed(() => [
  {
    title: t("entities.manufacturingStep.fields.name_tool_or_fixture"),
    key: "name",
    sortable: true
  },
  {
    title: t("entities.manufacturingStep.fields.costs_tool_or_fixture"),
    key: "costs_tool_or_fixture",
    sortable: true,
    value: (item) =>
      new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(
        item.tool_costs_tool || item.fixture_costs_fixture
      )
  }
]);
</script>

<style scoped lang="scss">
:deep() .v-data-table-header__content {
  font-weight: 700;
  font-size: smaller;
}

:deep()
  .border-table
  .v-table__wrapper
  > table
  > thead
  > tr
  > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

:deep()
  .border-table
  .v-table__wrapper
  > table
  > tbody
  > tr
  > td:not(:last-child),
.border-table .v-table__wrapper > table > tbody > tr > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.bottom_table {
  font-size: 85%;

  .wide_col {
    width: 280px;
  }

  .input_col {
    //width: 80px;
    padding: 0 6px !important;

    .v-field__input {
      min-height: 10px !important;
    }
  }

  .e_per_piece_col {
    width: 30px;
    padding: 0 6px !important;
    white-space: nowrap;
  }

  td,
  th {
    border-bottom: none !important;
  }

  .low-height {
    td,
    th {
      height: 40px !important;
    }
  }

  .v-field__input {
    padding: 4px 8px !important;
  }
}
</style>
